<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Zusammenfassung</h3>
    {{nordrheinWestfalenBericht?.zusammenfassung}}
  </div>
  <div class="bericht-text-container">
    <h3>Vorhersagen</h3>
    <div><b>Heute</b></div>
    {{nordrheinWestfalenBericht?.vorhersageHeute}}
    <div><b>Kommende Nacht</b></div>
    {{nordrheinWestfalenBericht?.vorhersageKommendeNacht}}
  </div>
  <div class="bericht-text-container">
    <h3>Aussichten</h3>
    <ng-container *ngFor="let aussichtTag of nordrheinWestfalenBericht?.aussichten?.aussichtsListe">
      <span class="bericht-text-sub-label">{{aussichtTag.datum | date: 'EEE dd.MM'}}</span>
      {{aussichtTag.text}}
    </ng-container>
  </div>
</div>
